import { useDashboard } from '../../../common/hooks'
import type { ProcessAnalysisConfig } from '../types'
import TrackedProcessName from './TrackedProcessName'
import TrackedProcessStat from './TrackedProcessStat'

interface Props {
  process: ProcessAnalysisConfig
  totalAppUsageTrendMapper: { [key: string]: number }
}

const TrackedProcessCard = ({ process, totalAppUsageTrendMapper }: Props) => {
  const {
    company: { isPmCustomer },
  } = useDashboard()

  return isPmCustomer ? (
    <TrackedProcessName process={process} />
  ) : (
    <TrackedProcessStat process={process} totalAppUsageTrendMapper={totalAppUsageTrendMapper} />
  )
}

export default TrackedProcessCard
